import cn from "classnames";
import Select, { customFilterSelectStyles, defaultMultipleSelectProps, ValueContainer } from "components/shared/select";
import { bidPointLoadUnloadStatuses, bidStatuses, carPlanningStatuses } from "helpers/enums";
import Check from "icons/planning/check.svg";
import Times from "icons/planning/times.svg";
import React from "react";
import { namesList } from "sources/books/drivers";
import { list as logistsList } from "sources/books/employees";
import { list as getRegionGroups } from "sources/books/regionGroups";
import { list as trailersList } from "sources/books/trailers";
import { numbersList } from "sources/books/trucks";
import { getListForSelect as getUsersGroups } from "sources/books/usersGroups";
import { getResponsibles } from "sources/tripPlanning";

export default function Filter(props) {
    const { resetFilters, filtered, onFilteredChange } = props;
    const selectProps = {
        ...defaultMultipleSelectProps,
        styles: { ...customFilterSelectStyles },
        components: { ValueContainer },
    };
    const togglerCname = (name) => cn("p-filter__tag--wrap", { "p-filter__tag--wrap-selected": filtered[name]?.value });

    const setFilter = ({ name, value, option }) => onFilteredChange({ id: name, value, option });
    const toggleFilter = (name) => setFilter({ name, value: !filtered[name]?.value });

    return (
        <div className="p-filter">
            <div className="p-filter__title">Фильтр</div>
            <div className="b-filter__body">
                <div className="b-filter__body-column">
                    <div className="pb-1">
                        <Select
                            {...selectProps}
                            inputProps={{ name: "car/id" }}
                            url={numbersList}
                            placeholder="По грузовику"
                            onChange={setFilter}
                            propName="number"
                            value={filtered["car/id"]?.value}
                        />
                    </div>
                    <div className="pb-1">
                        <Select
                            {...selectProps}
                            inputProps={{ name: "trailer/id" }}
                            url={trailersList}
                            placeholder="По прицепу"
                            onChange={setFilter}
                            propName="number"
                            value={filtered["trailer/id"]?.value}
                        />
                    </div>
                    <div className="pb-1">
                        <Select
                            {...selectProps}
                            inputProps={{ name: "driver/id" }}
                            url={namesList}
                            filterPropName="fullName"
                            propName="fullName"
                            placeholder="По водителю"
                            onChange={setFilter}
                            value={filtered["driver/id"]?.value}
                        />
                    </div>
                    <div className="pb-1">
                        <Select
                            {...selectProps}
                            inputProps={{ name: "car/logistId" }}
                            url={logistsList}
                            placeholder="По логисту машины"
                            onChange={setFilter}
                            propName="fullNameOrEmail"
                            value={filtered["car/logistId"]?.value}
                        />
                    </div>
                </div>
                <div className="b-filter__body-column">
                    <div className="pb-1">
                        <Select
                            {...selectProps}
                            inputProps={{ name: "carPlanningStatus" }}
                            options={carPlanningStatuses}
                            placeholder="По статусу машины"
                            onChange={setFilter}
                            value={filtered.carPlanningStatus?.value}
                        />
                    </div>
                    <div className="pb-1">
                        <Select
                            {...selectProps}
                            inputProps={{ name: "bidStatus" }}
                            options={bidStatuses}
                            placeholder="По статусу заявки"
                            onChange={setFilter}
                            value={filtered.bidStatus?.value}
                        />
                    </div>
                    <div className="pb-1">
                        <Select
                            {...selectProps}
                            inputProps={{ name: "bidPointLoadUnloadStatus" }}
                            options={bidPointLoadUnloadStatuses}
                            placeholder="По статусу загрузки"
                            onChange={setFilter}
                            value={filtered.bidPointLoadUnloadStatus?.value}
                        />
                    </div>
                    <div className="pb-1">
                        <Select
                            {...selectProps}
                            inputProps={{ name: "responsibleId" }}
                            url={getResponsibles}
                            placeholder="По ответственному"
                            onChange={setFilter}
                            propName="displayName"
                            value={filtered.responsibleId?.value}
                        />
                    </div>
                    <div className="pb-1">
                        <Select
                            {...selectProps}
                            inputProps={{ name: "userGroupId" }}
                            url={getUsersGroups}
                            placeholder="По группе пользователей"
                            onChange={setFilter}
                            propName="name"
                            value={filtered.userGroupId?.value}
                        />
                    </div>
                    <div className="pb-1">
                        <Select
                            {...selectProps}
                            inputProps={{ name: "regionGroupId" }}
                            url={getRegionGroups}
                            filterPropName="id"
                            propName="name"
                            placeholder="По группе регионов"
                            onChange={({ name, value, option }) => {
                                const newValue = value?.length
                                    ? {
                                          value,
                                          regionIds: option.reduce((acc, curr) => [...acc, ...curr.regionIds], []),
                                      }
                                    : null;

                                setFilter({
                                    name,
                                    value: newValue,
                                });
                            }}
                            value={filtered.regionGroupId?.value?.value}
                            components={{ ValueContainer }}
                        />
                    </div>
                </div>
                <div className="b-filter__body-column">
                    <div className={togglerCname("onlyMyCars")} onClick={toggleFilter.bind(this, "onlyMyCars")}>
                        {filtered.onlyMyCars?.value ? <Times /> : <Check />}
                        <span className="p-filter__tag--text">Только мои машины</span>
                    </div>
                </div>
            </div>
            <div className="planning-btn planning-btn--inline float-right" onClick={resetFilters}>
                <Times /> Сбросить
            </div>
        </div>
    );
}
